export default {
  init() {
    $(".hamburger").on("click", function() {
		$(this).toggleClass("is-active");
		if ($(this).hasClass("is-active")) {
			$("body").addClass("menu-open");
		} else {
			$("body").removeClass("menu-open");
		}
	});
	$(window).resize(function() {
		if ($(window).width() > 767) {
			$("body").removeClass('menu-open');
			$(".hamburger").removeClass("is-active");
		}
	});

	$('[data-src]').waypoint({
		handler: function() {
			var src = $(this.element).attr('data-src');
			$(this.element).attr('src', src);
		},
		offset: '105%',
	});

	$('[data-style]').waypoint({
		handler: function() {
			var style = $(this.element).attr('data-style');
			$(this.element).attr('style', style);
		},
		offset: '105%',
	});
  	$('.gform_footer input.gform_submit_button_3', this).click(function() {
	  	$('.gform_footer input.gform_submit_button_3').css('display','none');
  	});

	$('.topnav ul#menu-primary-menu > li').hover(function() {
		$(this).addClass('focus-within');
		$(this).siblings().removeClass('focus-within');
		$(this).find('ul').addClass('show');
		$(this).siblings().find('ul').removeClass('show');
		console.log('hover!');
	}, function() {
		$(this).removeClass('focus-within');
	});

	$('.topnav ul#menu-primary-menu > li ul').hover(function() {
		return true;
	}, function() {
		$(this).removeClass('show');
	});

	$('dialog.alert .close').on('click', function() {
		var $alert = $(this).parents('dialog.alert');
		$.ajax({
			url: ajaxurl,
			method: 'POST',
			data: {
				action: 'close_alert',
				alert: $alert.data('id'),
			},
			success: function(data) {
				$alert.detach();
			},
		});
	});

	$('select').comboSelect();

	$('.date').datepicker();

	$('input[type="submit"]').each(function() {
		var classes = $(this).attr('class');
		$(this).wrap("<div class='button-wrapper "+classes+"'></div>");
		$(this).attr('class', '');
	});

	$(".tab-nav .tab-content").each(function() {
		var id = "#"+$(this).attr('id');
		if (!$('a[href="'+id+'"]').hasClass('current')) {
			$(this).hide();
		}
	});

	$('.tab-nav .tabs a').on('click', function(e) {
		e.preventDefault();
		var id = $(this).attr('href');
		$('.tab-content'+id).show().siblings('.tab-content').hide();
		$(this).addClass('current').parent().siblings().find('a').removeClass('current');
	});

	$('ul.accordion header a').on('click', function(e) {
		e.preventDefault();
		var $header = $(this).parent('header');
		$header.toggleClass('open');
		if ($header.hasClass('open')) {
			$header.siblings('article').slideDown();
		} else {
			$header.siblings('article').slideUp();
		}
		$header.parent('li').siblings().find('header').removeClass('open');
		$header.parent('li').siblings().find('article').slideUp();
	});

	$('.filters a').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('current');
		$(this).parents('.stop-detail').find('table tbody tr').hide();
		$(this).parents('.filters').find('a').each(function() {
			if ($(this).hasClass('current')) {
				var slug = $(this).attr('href').replace('#', '');
				$(this).parents('.stop-detail').find('table tr.'+slug).show();
			}
		});
	});

	$('body').on('click', function(e) {
		if ($(e.target).closest('.filters').length == 0) {
			$('.filter-wrapper').removeClass('focus-within');
		}
	});

	$('.filter-link').on('focus mouseenter', function() {
		$(this).parents('.filter-wrapper').addClass('focus-within');
	});

	$('.filters').on('mouseleave', function() {
		$(this).parents('.filter-wrapper').removeClass('focus-within');
	});

	$('.gform_wrapper form').on('submit', function() {
		$(this).addClass('submitting');
	});

	$('footer .nav a[href="#"]').on('click focus', function(e) {
		e.preventDefault();
		return false;
	});
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js